<script>
import BaseImportUpload from './BaseImportUpload.vue'
import ListPreloader from './ListPreloader.vue'
export default {
  mixins: [BaseImportUpload],
  components: {ListPreloader},
  emits: {
    back: null,
    addListItem: null,
    uploadError: null,
    uploadStart: null,
  },
}
</script>

<template>
  <div class="position-relative">
    <div class="text-center" :style="{opacity: this.isLoading ? 0.1 : 1}">
      <div class="row mb-3 mb-md-4">
        <div class="col-md-8">
          <p class="m-0 para-blue text-start">{{ $t('lists: upload list items info') }}</p>
        </div>
        <div class="col-md-4 text-md-end">
          <a :href="`/lists/import_template/?list=${this.itemId}`" class="btn btn-light d-inline-flex gap-2 align-items-center"><i class="ph ph-download-simple"></i> {{ $t('lists: import template') }} <i class="ph ph-caret-right ms-auto"></i></a>
        </div>
      </div>
      <p class="mb-0 fs-13 mx-auto text-start" style="max-width: 430px">{{ $t('lists: upload list items') }} <i class="ph ph-asterisk"></i></p>
      <div class="px-3 py-4 mx-auto btn-media-import-upload" style="max-width: 430px" :class="{'border-success': this.isDragOver}">
        <div class="d-flex gap-3 align-items-center position-relative">
          <div class="bg-light rounded-circle d-flex align-items-center justify-content-center fs-3" style="width: 48px; height: 48px">
            <i class="ph ph-upload-simple"></i>
          </div>
          <div class="text-start">
               <span class="select-title fw-semibold fs-14">
                 {{ $t('drag file here or') }}
                  <span class="text-decoration-underline color-cyan-600">{{$t('upload it')}}</span>
                  {{$t('from computer')}}
              </span>
            <!--            <p class="m-0 fs-14 fw-semibold">{{ $t('upload or select files') }}</p>-->
            <p class="m-0 text-light-emphasis fst-italic fs-12">{{ $t('max file size') }}: {{ this.mediaConfig?.max_size }}MB</p>
            <p class="m-0 text-light-emphasis fst-italic fs-12">{{ $t('media: upload allowed types') }}: {{ this.mediaConfig?.validTypes?.join(', ') }}</p>
<!--            <p v-if="this.lastUploadError !== null" class="mb-0 mt-3 text-danger">{{ this.lastUploadError}}</p>-->
          </div>
          <input
              :disabled="isUploading"
              :class="{'d-none': this.isUploading}"
              ref="file"
              class="position-absolute w-100 h-100 top-0 left-0 opacity-0"
              style="cursor: pointer"
              type="file"
              :accept="this.mediaConfig?.validTypes?.map( t => `.${t}`)?.join(',')"
              @change="onFileSelect"
              @dragenter="event => onDragEnter(event)"
              @dragleave="event => onDragLeave(event)"
          >
        </div>
      </div>
      <div class="my-3 para-blue">{{ $t('or') }}</div>
      <button type="button" class="btn btn-primary mb-3 d-flex gap-2 align-items-center mx-auto" @click="this.$emit('addListItem')">
        {{ $t('lists: add founder') }} <i class="fa-solid fa-plus"></i>
      </button>
    </div>
    <ListPreloader text="" v-if="isLoading"/>
  </div>
</template>